import { render, staticRenderFns } from "./LandingBanner.vue?vue&type=template&id=1f37fcf6&scoped=true"
import script from "./LandingBanner.vue?vue&type=script&lang=js"
export * from "./LandingBanner.vue?vue&type=script&lang=js"
import style0 from "./LandingBanner.vue?vue&type=style&index=0&id=1f37fcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37fcf6",
  null
  
)

export default component.exports